import React, { useCallback, useState } from 'react';
import {
  bool,
  func,
  number,
  shape,
  string,
} from 'prop-types';
import { useMutation } from '@apollo/client';

import { formatSeconds } from '@playbookux/playbook-web-core';
import {
  Accordion,
  Icon,
  TaskNumberContainer,
  AccordionTitleContainer,
  Container,
  ContainerLeft,
  ContainerRight,
  NowPlaying,
  PlayIcon,
  PlayText,
  PlayContainer,
} from './styles';

import range from '../../../../core/components/video-tab/questions/range-question';
import url from '../../../../core/components/video-tab/questions/url-question';
import task from '../../../../core/components/video-tab/questions/task-question';
import written from '../../../../core/components/video-tab/questions/written-question';
import selectQuestion from '../../../../core/components/video-tab/questions/select-question';
import { EDIT_ANSWER_TRANSCRIPT } from '../../../../core/graphql/test-sessions';

const questionTypes = {
  range,
  url,
  task,
  written,
  multiple_select: selectQuestion,
  single_select: selectQuestion,
  image_select: url,
  audio_video: url,
};

const getStartTime = (answer) => {
  if (!answer) {
    return '00:00';
  }

  return (
    <time>
      {formatSeconds(answer.videoStartTime)}
    </time>
  );
};

const getTimeOnTask = (answer) => {
  if (!answer) {
    return '00:00';
  }

  return (
    <time>
      {formatSeconds(answer.videoEndTime - answer.videoStartTime)}
    </time>
  );
};

const VideoQuestions = (props) => {
  const {
    user,
    question,
    answer,
    onClick,
    index,
    isVideoPlaying,
  } = props;

  const [active, setActive] = useState(true);

  const handleClickQuestion = useCallback(() => {
    setActive(!active);
  }, [active, setActive]);

  const handleClickTranscript = useCallback(() => {
    if (typeof onClick === 'function') onClick();
  }, [onClick]);

  const QuestionLayout = questionTypes[question.questionType];

  const { firstName = '' } = user?.profile || {};

  const [editTranscript] = useMutation(EDIT_ANSWER_TRANSCRIPT);

  const handleChangeTranscript = (id, text) => {
    editTranscript({
      variables: {
        testSessionAnswerId: id,
        transcript: text,
      },
    });
  };

  return (
    <Container>
      <Accordion.Title
        active={active}
        index={index}
      >
        <AccordionTitleContainer>
          <ContainerLeft>
            <TaskNumberContainer>{firstName}</TaskNumberContainer>
            {
              isVideoPlaying ? (
                <NowPlaying>Now Playing</NowPlaying>
              ) : (
                <PlayContainer onClick={handleClickTranscript}>
                  <PlayText>
                    Play
                  </PlayText>
                  <PlayIcon
                    size="mini"
                    name="play circle"
                  />
                </PlayContainer>
              )
            }
          </ContainerLeft>
          <ContainerRight>
            <Icon
              name={active ? 'chevron up' : 'chevron down'}
              onClick={handleClickQuestion}
            />
          </ContainerRight>

        </AccordionTitleContainer>
      </Accordion.Title>

      <QuestionLayout
        question={question}
        startTime={getStartTime(answer)}
        onClick={handleClickQuestion}
        index={index}
        active={active}
        answer={answer}
        timeOnTask={getTimeOnTask(answer)}
        onSubmit={(value) => handleChangeTranscript(answer.id, value)}
        onRemoveTagHighlight={() => { }}
      />
    </Container>
  );
};

VideoQuestions.propTypes = {
  user: shape({
    id: string,
    profile: shape({
      firstName: string,
    }),
  }).isRequired,
  question: shape({
    questionType: string,
    label: string,
    imageUrl: string,
    videoUrl: string,
  }).isRequired,
  answer: shape({
    id: string,
  }).isRequired,
  onClick: func,
  index: number.isRequired,
  isVideoPlaying: bool,
};

VideoQuestions.defaultProps = {
  onClick: () => { },
  isVideoPlaying: false,
};

export default VideoQuestions;
